require('../../jsy_do_widokow_z_salami/sale/parter/row1.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row2.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row3.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row4.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row5.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row6.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row7.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row8.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row9.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row10.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row11.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row12.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row13.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row14.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row15.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row16.js');
require('../../jsy_do_widokow_z_salami/sale/parter/row17.js');
